export enum TravelType {
    PublicTransport = 'public_transport',
    Driving = 'driving',
    Cycling = 'cycling',
    Walking = 'walking',
    PublicTransportAndCycling = 'cycling+public_transport'
}
